import $ from 'jquery';
import modalFunctions from '../modal-form';

const header = $('header.header-section'),
  topbanner = $('#topbanner'),
  wpmlCurrentLangLink = $('.wpml-ls-current-language > a'),
  h3Elements = $('h3');

wpmlCurrentLangLink.on('click', function (e) {
  e.preventDefault();
});

$.fn.extend({
  toggleHtml: function (a, b) {
    return this.html(this.html() == b ? a : b);
  },
});

function fixedHeader(scrollBlock, header) {
  scrollBlock.on('scroll', function () {
    if (scrollBlock.scrollTop() > 5) {
      $('body').addClass('scrolled');
      header.addClass('scrolled');
      if(topbanner.length > 0) {
        topbanner.removeClass('down').addClass('up');
      }
    } else {
      $('body').removeClass('scrolled');
      header.removeClass('scrolled');
      if(topbanner.length > 0) {
        topbanner.removeClass('up').addClass('down');
      }
    }
  });
}

fixedHeader($(document), header);

h3Elements.each(function () {
  let title = $(this).text();
  $(this).attr('title', title);
});

const showForm = $('.pricing-button'),
  formModal = $('.form-modal-pricing.request-pricing-popup'),
  formModalClose = $(
    '.form-modal-pricing.request-pricing-popup .form-modal__close'
  ),
  focusableElements =
    'a, button, input, textarea, select, details, iframe, embed, object, summary dialog, audio[controls], video[controls], [contenteditable], [tabindex]',
  mainContentFocusableEls = $('main').find(focusableElements),
  headerContentFocusableEls = $('header').find(focusableElements),
  footerContentFocusableEls = $('footer').find(focusableElements),
  formFocusableEls = formModal.find(focusableElements),
  htmlEL = $('html'),
  modalArgs = {
    mainContentFocusableEls,
    headerContentFocusableEls,
    footerContentFocusableEls,
    formFocusableEls,
    formModal,
    htmlEL,
  };
modalFunctions.setFormAttr(formModal, formFocusableEls);
showForm.on('click', function (e) {
  modalFunctions.openModal(e, modalArgs);
});

formModalClose.on('click', function () {
  modalFunctions.closeModal(modalArgs);
});

formModal.on('click', function (e) {
  if ($(e.target).is(this)) {
    modalFunctions.closeModal(modalArgs);
  }
});

$(document).on('keydown', function (e) {
  if (e.key == 'Escape') {
    let modalAria = formModal.attr('aria-hidden');
    if (modalAria) {
      modalFunctions.closeModal(modalArgs);
    }
  }
});

//show banner
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const banner = document.getElementById('topbanner');
  if (urlParams.get('source') === 'vitac') {
    if (banner) {
      banner.classList.add('visible');
    }
  }
});